"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const reducers_1 = require("../../../reducers");
const AlertOptionsRows = ({ deliverable, device, displayText, field, handleAlertOptionsModalDisplay, handleHover, isHovered, updateNotificationDeliverable, }) => {
    const { alertOptions } = deliverable;
    const { badgeNumber, notificationCenter, systemNotification } = alertOptions;
    const handleSwitchChange = () => {
        if (field === 'badgeNumber') {
            if (!notificationCenter) {
                return;
            }
            return updateNotificationDeliverable({
                alertOptions: Object.assign(Object.assign({}, alertOptions), { badgeNumber: !badgeNumber }),
            });
        }
        if (field === 'notificationCenter') {
            return updateNotificationDeliverable({
                alertOptions: Object.assign(Object.assign({}, alertOptions), { notificationCenter: !notificationCenter, badgeNumber: false }),
            });
        }
        return updateNotificationDeliverable({
            alertOptions: Object.assign(Object.assign({}, alertOptions), { [field]: !alertOptions[field] }),
        });
    };
    const getSwitchValue = () => {
        if (field === 'badgeNumber') {
            return notificationCenter === false ? false : badgeNumber;
        }
        return alertOptions[field];
    };
    const getSwitchDisableStyle = () => {
        if (field === 'badgeNumber') {
            if (notificationCenter === false) {
                return {
                    outerStyle: {
                        background: src_1.mercury,
                    },
                };
            }
        }
        return {
            outerStyle: {
                background: alertOptions[field] ? src_1.turquoise : src_1.titanium,
            },
        };
    };
    const getTextStyle = () => {
        if (field === 'badgeNumber' && deliverable.alertOptions.notificationCenter === false) {
            return {
                color: src_1.silver,
            };
        }
    };
    const style = isHovered
        ? {
            marginLeft: -32,
            marginRight: -32,
            paddingRight: 32,
            paddingLeft: 32,
            background: src_1.beige,
        }
        : {
            marginLeft: -32,
            marginRight: -32,
            paddingRight: 32,
            paddingLeft: 32,
        };
    return (React.createElement("div", { style: Object.assign({}, style), onMouseEnter: () => handleHover(field), onMouseLeave: () => handleHover(''), onClick: () => handleSwitchChange(), id: `${field}_alertOptionsRow` },
        React.createElement("div", { style: {
                display: 'flex',
                height: 71,
                justifyContent: 'space-between',
                alignItems: 'center',
                overflow: 'hidden',
                borderBottom: `1px solid ${src_1.titanium}`,
                position: 'relative',
            } },
            React.createElement(src_1.Text, { text: displayText, size: "large", label: true, textStyle: getTextStyle() }),
            React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                device !== 'Desktop' && (React.createElement("div", { onClick: (e) => {
                        e.stopPropagation();
                        handleAlertOptionsModalDisplay(field);
                    }, style: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement(src_1.AlertInfoIcon, { fill: src_1.turquoise, style: { marginRight: 16 } }))),
                React.createElement(src_1.Switch, { on: getSwitchValue(), style: getSwitchDisableStyle(), onClick: () => handleSwitchChange() })))));
};
const mapStateToProps = (state) => ({
    deliverable: reducers_1.getEditableCampaignDeliverable(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        handleAlertOptionsModalDisplay: (deviceInfoSelected) => {
            dispatch(actions_1.handleAlertOptionsModalDisplay(deviceInfoSelected));
        },
        updateNotificationDeliverable: (d) => {
            dispatch(actions_1.updateNotificationDeliverable(d));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AlertOptionsRows);
